import type {
  LotStoryArtifactDetailV1,
  LotStoryArtifactVersionV1
} from '../../types/lotStory'
import type {
  TranslateFn
} from './lotStoryLibraryTypes'
import LotStoryLibraryComparePanel from './LotStoryLibraryComparePanel'
import LotStoryLibraryVersionHistoryRow from './LotStoryLibraryVersionHistoryRow'
import type { LotStoryLibraryPresentation } from './lotStoryPresentation'
import useLotStoryLibraryVersionHistoryState from './useLotStoryLibraryVersionHistoryState'

type LotStoryLibraryVersionHistoryProps = {
  t: TranslateFn
  artifact: LotStoryArtifactDetailV1
  selectedStoryPreviewVersionId: string | null
  onOpenArtifactVersion: (artifact: LotStoryArtifactDetailV1, version: LotStoryArtifactVersionV1) => void
  presentation: LotStoryLibraryPresentation
}

export default function LotStoryLibraryVersionHistory({
  t,
  artifact,
  selectedStoryPreviewVersionId,
  onOpenArtifactVersion,
  presentation
}: Readonly<LotStoryLibraryVersionHistoryProps>) {
  const {
    compareState,
    compareActions,
    rowCompareState,
    rowCompareActions,
    rowPreviewState,
    rowPreviewActions
  } = useLotStoryLibraryVersionHistoryState({
    artifact,
    selectedStoryPreviewVersionId,
    onOpenArtifactVersion
  })

  return (
    <div style={{ display: 'grid', gap: 10 }}>
      <div>
        <strong style={{ display: 'block', fontSize: 13, color: '#92400e' }}>{t('lots.story.library.history.title')}</strong>
        <div style={{ marginTop: 2, fontSize: 12, color: '#475569' }}>{t('lots.story.library.history.subtitle')}</div>
      </div>

      {compareState ? (
        <LotStoryLibraryComparePanel
          t={t}
          compareState={compareState}
          compareActions={compareActions}
          presentation={presentation}
        />
      ) : null}

      <div style={{ display: 'grid', gap: 10 }}>
        {artifact.versions.map((version) => {
          return (
            <LotStoryLibraryVersionHistoryRow
              key={version.artifactVersionId}
              t={t}
              artifact={artifact}
              version={version}
              previewState={rowPreviewState}
              previewActions={rowPreviewActions}
              compareState={rowCompareState}
              compareActions={rowCompareActions}
              presentation={presentation}
            />
          )
        })}
      </div>
    </div>
  )
}